const urls = import.meta.glob<string>(
  "../../../../attached_assets/jands-drive/main/*.jpg",
  { eager: true, import: "default", query: "?url" }
);

const portraitUrls = import.meta.glob<string>(
  "../../../../attached_assets/jands-drive/portrait-900x1200/*.jpg",
  { eager: true, import: "default", query: "?url" }
);

const mainWebpLg = import.meta.glob<string>(
  "../../../../attached_assets/jands-drive/main-webp/*.webp",
  { eager: true, import: "default", query: "?url" }
);

const mainWebpSm = import.meta.glob<string>(
  "../../../../attached_assets/jands-drive/main-webp-small/*.webp",
  { eager: true, import: "default", query: "?url" }
);

const mainAvifLg = import.meta.glob<string>(
  "../../../../attached_assets/jands-drive/main-avif/*.avif",
  { eager: true, import: "default", query: "?url" }
);

const mainAvifSm = import.meta.glob<string>(
  "../../../../attached_assets/jands-drive/main-avif-small/*.avif",
  { eager: true, import: "default", query: "?url" }
);

const portWebpLg = import.meta.glob<string>(
  "../../../../attached_assets/jands-drive/portrait-webp/*.webp",
  { eager: true, import: "default", query: "?url" }
);

const portWebpSm = import.meta.glob<string>(
  "../../../../attached_assets/jands-drive/portrait-webp-small/*.webp",
  { eager: true, import: "default", query: "?url" }
);

const portAvifLg = import.meta.glob<string>(
  "../../../../attached_assets/jands-drive/portrait-avif/*.avif",
  { eager: true, import: "default", query: "?url" }
);

const portAvifSm = import.meta.glob<string>(
  "../../../../attached_assets/jands-drive/portrait-avif-small/*.avif",
  { eager: true, import: "default", query: "?url" }
);

const DIMS: Record<string, [number, number]> = {
  "123438473_118350966732432_6009668417626056132_n.jpg": [720, 960],
  "123464472_118350946732434_1145323556165989190_n.jpg": [720, 960],
  "123514243_117079100192952_2864826936074748121_n.jpg": [960, 720],
  "123618684_122103739690488_6732449231368244454_n.jpg": [720, 960],
  "123632044_117078293526366_671727122752374726_n.jpg": [960, 720],
  "123646579_117078936859635_8828902820891312578_n.jpg": [720, 960],
  "123653746_117078480193014_8284348255752854202_n_rec_room_condo.jpg": [960, 720],
  "123655961_117079023526293_4388491792332026681_n_JimmyII.jpg": [720, 960],
  "123737683_117079000192962_4640042108274870887_n.jpg": [720, 960],
  "123747812_117078723526323_701472696429576817_n.jpg": [720, 960],
  "123764525_117078230193039_8566755487552150567_n.jpg": [960, 720],
  "123767439_117078180193044_5007711255479923881_n-ceiling_speaker.jpg": [720, 960],
  "123768131_117078040193058_1398289613860062061_n.jpg": [960, 720],
  "123768501_117078893526306_6850827009561334181_n_exposed_wires_were_clients_preference.jpg": [960, 720],
  "123768578_117078960192966_8164404138524212922_n.jpg": [720, 960],
  "123770212_117078620193000_8722302865507322614_n.jpg": [960, 720],
  "123771534_117078553526340_1567278574997170006_n.jpg": [720, 960],
  "123771939_117078013526394_4397432469577363882_n.jpg": [720, 960],
  "123771943_117078790192983_86670953675662766_n.jpg": [960, 720],
  "123773256_117078810192981_6362594107935173561_n.jpg": [720, 960],
  "123773330_117078860192976_4738540335975228096_n.jpg": [960, 720],
  "123778409_117078050193057_7175486334557088894_n.jpg": [960, 720],
  "123779524_118350933399102_3448575868960814239_n.jpg": [720, 960],
  "123780507_117078333526362_7702693071080525397_n.jpg": [720, 960],
  "123788749_117078743526321_6631294139466132632_n.jpg": [720, 960],
  "123791169_117078546859674_7168799985613140324_n.jpg": [720, 960],
  "123798771_117078583526337_3296195577347654809_n.jpg": [960, 720],
  "123799075_117078356859693_5450365466734271589_n.jpg": [720, 960],
  "123800437_117078403526355_521427370293197632_n.jpg": [960, 720],
  "123800437_117079073526288_7468524805370010714_n.jpg": [720, 960],
  "123807878_117079013526294_2139534731866966073_n_Jimmy.jpg": [720, 960],
  "123809155_117078660192996_6133890053147235599_n.jpg": [960, 720],
  "123809155_117078926859636_6805367968263047726_n.jpg": [540, 960],
  "123813675_117078776859651_7406927408465354559_n.jpg": [960, 540],
  "123813677_117078773526318_1074484386067925521_n.jpg": [960, 720],
  "123814606_117078113526384_4141078589261753113_n.jpg": [720, 960],
  "123817440_117078140193048_4559145075267125301_n.jpg": [720, 960],
  "123817440_117078436859685_6823191246193875934_n_outdoor_tv.jpg": [720, 960],
  "123820457_117078103526385_901300653897054391_n.jpg": [960, 720],
  "123824938_117078326859696_6003523516164649744_n.jpg": [720, 960],
  "123827203_117078280193034_8367739927061682909_n.jpg": [960, 720],
  "123828147_117078196859709_6456184889146806931_ntv_mount_into_masonry.jpg": [720, 960],
  "123829016_117078626859666_2446716433118441475_n-wall-mount-restaurant-ii.jpg": [960, 720],
  "123829016_117078626859666_2446716433118441475_n-wall-mount-restaurant.jpg": [960, 720],
  "123834617_117078663526329_4539926280097417230_n.jpg": [960, 720],
  "123837266_117078856859643_5762567078477408491_n.jpg": [960, 720],
  "123842411_122103756357153_4361565945749692692_n.jpg": [720, 960],
  "123849281_117078150193047_7292716948581245755_ceiling_speaker.jpg": [720, 960],
  "123850417_117079006859628_1261535379521205161_n_speakers_designed_by_other_company.jpg": [960, 720],
  "123907376_117078220193040_1504604141583354519_n.jpg": [960, 720],
  "123919310_117078396859689_3595991169783621965_n.jpg": [960, 720],
  "123920449_117078880192974_2416327701161857967_n.jpg": [960, 720],
  "123920770_117078703526325_3515449920656740321_n.jpg": [720, 960],
  "123924442_117079076859621_1258839345679467136_n.jpg": [720, 960],
  "123925248_117078963526299_1947393982944703981_n.jpg": [960, 720],
  "123931174_117078590193003_5940783716599573452_n.jpg": [960, 720],
  "123939441_120302983203897_440704254868048531_n-TV-plus-bose.jpg": [720, 960],
  "124029836_117078363526359_2329258821995492817_n.jpg": [960, 720],
  "124280867_123847906182738_9119150790953311646_n.jpg": [960, 720],
  "124432972_123847889516073_2483398649782806255_n.jpg": [960, 720],
  "125276412_124728389428023_6653312294005528754_n.jpg": [720, 960],
  "125515280_124728399428022_3343374875172841924_n.jpg": [720, 960],
  "470184469_1048680073699512_158359209648468126_n.jpg": [960, 720],
  "470188250_1048687157032137_7373408924958511960_n.jpg": [960, 720],
  "471501502_1058531619381024_1699632199117910748_n-restaurant.jpg": [720, 960],
  "485380824_1154458716691288_3029746027615728547_n-sound-bar.jpg": [1536, 2048],
  "486124387_1154914376645722_829283885567137589_n_event_set_up.jpg": [1536, 2048],
  "486156498_1154897169980776_4519007158649887290_n-audio-video-leominster.jpg": [2048, 1536],
  "487919293_1164758165661343_3746231486655653021_n.jpg": [1536, 2048],
  "488245368_1164758188994674_4439072095243955357_n.jpg": [1536, 2048],
  "488655010_1165412298929263_8422537262457827383_n_audio_system_set_up.jpg": [1536, 2048],
  "488657372_1165411945595965_2800093043846313905_n-controllers.jpg": [2048, 1536],
  "490522160_1172513571552469_2319196569004136287_n-shrewsbury.jpg": [2048, 1536],
  "492255803_1183923180411508_549337840855625774_n.jpg": [1536, 2048],
  "Boston_Beacon_St.jpg": [1536, 2048],
  "J_S_TV_installation_services.jpg": [1536, 2048],
  "J_S_TV_installation_services_II.jpg": [1536, 2048],
  "J_S_TV_installation_services_III.jpg": [2048, 1536],
  "J_S_TV_installation_services_IV.jpg": [1536, 2048],
  "J_S_TV_installation_services_mendon.jpg": [1536, 2048],
  "J_S_home_theater_system_install_charlton_ma.jpg": [526, 701],
  "J_S_home_theater_fireplace_worcester_ma.jpg": [1536, 2048],
  "J_S_home_theater_system_install_hopkinton_ma.jpg": [1536, 2048],
  "j-s-audio-video-solutions-home-theater-tv-mount-600x450.jpg": [600, 450],
  "j-s-audio-video-solutions-uxbridge-home-theater-600x450.jpg": [600, 450],
  "J_S_outdoor_TV_installation_oakham_ma.jpg": [1536, 2048],
  "J_S_outdoor_bar_TV_installation_oakham_ma.jpg": [2048, 1536],
  "J_S_system_configuration.jpg": [1536, 2048],
  "J_S_system_configuration_ii.jpg": [1536, 2048],
  "J_S_system_configuration_iii.jpg": [720, 960],
  "J_S_video_equipment_framingham.jpg": [2048, 1536],
  "Sonos_beam_sound_bar.jpg": [720, 960],
  "TV_soundbar_Southboro.jpg": [2048, 1536],
  "event.jpg": [1536, 2048],
  "event_stage.jpg": [2048, 1536],
  "hero_photo_option.jpg": [960, 720],
  "shrewsbury-.jpg": [1308, 2048],
  "sound_bar_II.jpg": [1536, 2048],
  "stage_set_up.jpg": [2048, 1536],
};

export interface MainImage {
  src: string;
  width: number;
  height: number;
  isPortrait: boolean;
}

export function mainImg(filename: string): MainImage {
  const dims = DIMS[filename];
  if (!dims) {
    throw new Error(`mainImg: unknown filename '${filename}'`);
  }
  const isPortrait = dims[1] > dims[0];
  const portraitEntry = isPortrait
    ? Object.entries(portraitUrls).find(([k]) => k.endsWith("/" + filename))
    : undefined;
  if (isPortrait && portraitEntry) {
    return { src: portraitEntry[1], width: 900, height: 1200, isPortrait: true };
  }
  const entry = Object.entries(urls).find(([k]) => k.endsWith("/" + filename));
  if (!entry) {
    throw new Error(`mainImg: missing asset '${filename}'`);
  }
  return { src: entry[1], width: dims[0], height: dims[1], isPortrait };
}

export function portraitImg(filename: string): MainImage {
  const entry = Object.entries(portraitUrls).find(([k]) => k.endsWith("/" + filename));
  if (!entry) {
    throw new Error(`portraitImg: no portrait version for '${filename}'`);
  }
  return { src: entry[1], width: 900, height: 1200, isPortrait: true };
}

export interface GalleryImgData {
  imgSet: {
    avif1200: string;
    avif600: string;
    webp1200: string;
    webp600: string;
    fallback: string;
  };
  displayWidth: number;
  displayHeight: number;
  srcWidths: [number, number];
}

function findUrl(map: Record<string, string>, base: string, ext: string): string {
  const entry = Object.entries(map).find(([k]) => k.endsWith(`/${base}.${ext}`));
  return entry ? entry[1] : "";
}

export function galleryImgSet(filename: string): GalleryImgData {
  const dims = DIMS[filename];
  if (!dims) throw new Error(`galleryImgSet: unknown filename '${filename}'`);
  const isPortrait = dims[1] > dims[0];
  const base = filename.replace(/\.[^.]+$/, "");

  if (isPortrait) {
    const portEntry = Object.entries(portraitUrls).find(([k]) => k.endsWith("/" + filename));
    if (portEntry) {
      return {
        imgSet: {
          avif1200: findUrl(portAvifLg, base, "avif"),
          avif600:  findUrl(portAvifSm, base, "avif"),
          webp1200: findUrl(portWebpLg, base, "webp"),
          webp600:  findUrl(portWebpSm, base, "webp"),
          fallback: portEntry[1],
        },
        displayWidth: 900,
        displayHeight: 1200,
        srcWidths: [450, 900],
      };
    }
  }

  const [origW, origH] = dims;
  const scale = Math.min(800 / origW, 800 / origH, 1);
  const displayW = Math.round(origW * scale);
  const displayH = Math.round(origH * scale);
  const smallWidth = Math.min(400, origW);
  const largeWidth = Math.min(800, origW);
  const jpgEntry = Object.entries(urls).find(([k]) => k.endsWith("/" + filename));

  return {
    imgSet: {
      avif1200: findUrl(mainAvifLg, base, "avif"),
      avif600:  findUrl(mainAvifSm, base, "avif"),
      webp1200: findUrl(mainWebpLg, base, "webp"),
      webp600:  findUrl(mainWebpSm, base, "webp"),
      fallback: jpgEntry ? jpgEntry[1] : "",
    },
    displayWidth: displayW,
    displayHeight: displayH,
    srcWidths: [smallWidth, largeWidth],
  };
}
